<template>
  <div>
    <div v-if="banks.length > 0 && currentBank" class="select-bank">
      <button :disabled="isDisabled" @click="openSelectBankPop">
        <div
          class="item"
          :class="{'full-width': banks.length == 1 }"
          :style="{
            background: (currentBank.rgb
              ? `#${currentBank.rgb}`
              : 'linear-gradient(to right, #373b44, #4286f4)')
          }"
        >
          <div class="itemName">
            <em>
              <img
                :src="
                  require(`@/assets/images/bank/bank_icon/${allowedLogos.indexOf(currentBank.bank) >= 0 ? currentBank.bank : 'bank'}.${currentBank.bank === 'alipay' ? 'svg' : 'png'}`)
                "
              >
            </em>
          </div>
          <div class="itemNum">
            <span>{{ currentBank.bankName }}</span>
            <p class="item-detail">
              <span class="card-type">储蓄卡</span>
              <span>{{
                maskBankAccountNumber(currentBank.bankAccountNumber)
              }}</span>
            </p>
          </div>
        </div>
        <div v-if="banks.length > 1" class="dropdown-container">
          <em class="dropdown" />
        </div>
      </button>
    </div>
    <div v-if="showSelectBankPop" class="select-bank-pop">
      <div class="popFixed">
        <div class="masking" @click="closeSelectBankPop" />
        <div class="bottomCon">
          <div class="content">
            <div class="header single"><span class="center">银行卡</span></div>
            <ul>
              <li v-for="bank in banks" :key="bank.id" :class="{'checked': bank.id == selectedBank.id}">
                <div class="itemCheck" @click="selectBank(bank)">
                  <div
                    class="item"
                    :style="{
                      background: selectedBank.id == bank.id ? (bank.rgb
                        ? '#' + bank.rgb
                        : 'linear-gradient(to right, #373b44, #4286f4)')
                        : 'linear-gradient(to right, #919191, #c3c3c3)',
                    }"
                  >
                    <div class="itemName">
                      <em><img
                        :src="
                          require(`@/assets/images/bank/bank_icon/${allowedLogos.indexOf(bank.bank) >= 0 ? bank.bank : 'bank'}.${bank.bank === 'alipay' ? 'svg' : 'png'}`)
                        "
                      ></em>
                    </div>
                    <div class="itemNum">
                      <span>{{ bank.bankName }}</span>
                      <p class="item-detail">
                        <span class="card-type">储蓄卡</span>
                        <span>{{
                          maskBankAccountNumber(bank.bankAccountNumber)
                        }}</span>
                      </p>
                    </div>
                  </div>
                  <em />
                </div>
              </li>
            </ul>
          </div>
          <div class="btnCon">
            <a class="submit" @click="confirmBank(selectedBank)">确定</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/selectBank.css')
import { maskBankAccountNumber } from '@/utils/helper'
export default {
  name: 'SelectBank',
  props: [
    'onConfirmBank',
    'onOpen',
    'onClose',
    'currBank',
    'disabled',
    'bankList'
  ],
  data() {
    return {
      showSelectBankPop: false,
      selectedBank: this.currBank,
      currentBank: this.currBank,
      isDisabled: this.disabled || false,
      banks: this.bankList ? this.bankList : [],
      allowedLogos: process.env.VUE_APP_BANKLOGO
    }
  },
  watch: {
    currBank: function(newVal) {
      this.currentBank = newVal
      this.selectedBank = newVal
    },
    bankList: function(newVal) {
      this.banks = newVal
    },
    disabled: function(newVal) {
      this.isDisabled = newVal
    }
  },
  methods: {
    closeSelectBankPop() {
      this.showSelectBankPop = false
      this.selectedBank = this.currentBank
      this.$emit('onClose')
    },
    openSelectBankPop() {
      if (this.banks.length == 1) {
        return
      }
      this.showSelectBankPop = true
      this.$emit('onOpen')
    },
    selectBank(account) {
      this.selectedBank = account
    },
    confirmBank(account) {
      this.currentBank = account
      this.$emit('onConfirmBank', this.currentBank)
      this.closeSelectBankPop()
    },
    maskBankAccountNumber
  }
}
</script>
